import { createContext, useContext } from 'react';

export const RequestCommentContext = createContext({
    loading: false,
    setLoading: () => {},
    handleCmBoxCommentEditing: (planId) => {},
});

const useRequestCommentContext = () => {
    const context = useContext(RequestCommentContext);
    if (!context) {
        throw new Error('useRequestCommentContext must be used within a RequestCommentProvider');
    }
    return context;
};

export default useRequestCommentContext;
